// Action Types

export const Types = {
  TOKEN_VALIDATION_REQUESTED: 'auth/TOKEN_VALIDATION_REQUESTED',
  TOKEN_VALIDATION_SUCCEEDED: 'auth/TOKEN_VALIDATION_SUCCEEDED',
  TOKEN_VALIDATION_FAILED: 'auth/TOKEN_VALIDATION_FAILED',
  LOGIN_REQUESTED: 'auth/LOGIN_REQUESTED',
  LOGIN_SUCCEEDED: 'auth/LOGIN_SUCCEEDED',
  LOGIN_FAILED: 'auth/LOGIN_FAILED',
  LOGOUT: 'auth/LOGOUT',

  GET_AVATAR_REQUESTED: 'auth/GET_AVATAR_REQUESTED',
  GET_AVATAR_SUCCEEDED: 'auth/GET_AVATAR_SUCCEEDED',
  GET_AVATAR_FAILED: 'auth/GET_AVATAR_FAILED',

  GET_SUBORDINATES_REQUESTED: 'auth/GET_SUBORDINATES_REQUESTED',
  GET_SUBORDINATES_SUCCEEDED: 'auth/GET_SUBORDINATES_SUCCEEDED',
  GET_SUBORDINATES_FAILED: 'auth/GET_SUBORDINATES_FAILED',

  GET_SERVER_DATE_REQUESTED: 'auth/GET_SERVER_DATE_REQUESTED',
  GET_SERVER_DATE_SUCCEEDED: 'auth/GET_SERVER_DATE_SUCCEEDED',
  GET_SERVER_DATE_FAILED: 'auth/GET_SERVER_DATE_FAILED',

  CREATE_FOLDER_REQUESTED: 'auth/CREATE_FOLDER_REQUESTED',
  CREATE_FOLDER_SUCCEEDED: 'auth/CREATE_FOLDER_SUCCEEDED',
  CREATE_FOLDER_FAILED: 'auth/CREATE_FOLDER_FAILED',
}

// Action Creators

export function validateToken() {
  return {
    type: Types.TOKEN_VALIDATION_REQUESTED,
  }
}

export function login() {
  return {
    type: Types.LOGIN_REQUESTED,
  }
}

export function logout() {
  return {
    type: Types.LOGOUT,
  }
}

export function createProductFolder(targetUserEmail, nomeProjeto) {
  return {
    type: Types.CREATE_FOLDER_REQUESTED,
    payload: { targetUserEmail, nomeProjeto },
  }
}

export function getAvatar() {
  return {
    type: Types.GET_AVATAR_REQUESTED,
  }
}

export function getSubordinates() {
  return {
    type: Types.GET_SUBORDINATES_REQUESTED,
  }
}

export function getServerDate() {
  return {
    type: Types.GET_SERVER_DATE_REQUESTED,
  }
}

// Reducer

const INITIAL_STATE = {
  user: null,
  validationIsLoading: true,
  validToken: false,
  validationTokenError: null,
  loginIsLoading: false,
  loginError: null,
  getAvatarIsLoading: false,
  getAvatarError: null,
  getSubordinatesIsLoading: false,
  getSubordinatesError: null,
  getServerDateIsLoading: false,
  getServerDateError: null,
  isServerDateSync: false,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.TOKEN_VALIDATION_REQUESTED:
      return {
        ...state,
        validationIsLoading: true,
        validationTokenError: null,
      }
    case Types.TOKEN_VALIDATION_SUCCEEDED:
      return {
        ...state,
        validationIsLoading: false,
        validToken: true,
        validationTokenError: null,
        user: action.payload.user,
      }
    case Types.TOKEN_VALIDATION_FAILED:
      return {
        ...state,
        validationIsLoading: false,
        validToken: false,
        validationTokenError: action.payload,
        user: null,
      }

    case Types.LOGIN_REQUESTED:
      return {
        ...state,
        loginIsLoading: true,
        loginError: null,
        validationTokenError: null,
      }
    case Types.LOGIN_SUCCEEDED:
      return {
        ...state,
        loginIsLoading: false,
        loginError: null,
        user: action.payload.user,
        validToken: true,
      }
    case Types.LOGIN_FAILED:
      return {
        ...state,
        loginIsLoading: false,
        loginError: action.payload,
        validToken: false,
      }

    case Types.LOGOUT:
      return {
        ...state,
        validToken: false,
        user: null,
      }

    case Types.GET_AVATAR_REQUESTED:
      return {
        ...state,
        getAvatarIsLoading: true,
        getAvatarError: null,
      }
    case Types.GET_AVATAR_SUCCEEDED:
      return {
        ...state,
        getAvatarIsLoading: false,
        getAvatarError: null,
        user: {
          ...state.user,
          avatar: action.payload,
        },
      }
    case Types.GET_AVATAR_FAILED:
      return {
        ...state,
        getAvatarIsLoading: false,
        getAvatarError: action.payload,
      }

    case Types.GET_SUBORDINATES_REQUESTED:
      return {
        ...state,
        getSubordinatesIsLoading: true,
        getSubordinatesError: null,
      }
    case Types.GET_SUBORDINATES_SUCCEEDED:
      return {
        ...state,
        getSubordinatesIsLoading: false,
        getSubordinatesError: null,
        user: {
          ...state.user,
          isManager: action.payload.isManager,
          subordinates: action.payload.subordinates,
          oikos_id: action.payload.oikos_id,
        },
      }
    case Types.GET_SUBORDINATES_FAILED:
      return {
        ...state,
        getSubordinatesIsLoading: false,
        getSubordinatesError: action.payload,
      }

    case Types.GET_SERVER_DATE_REQUESTED:
      return {
        ...state,
        getServerDateIsLoading: true,
        getServerDateError: null,
        isServerDateSync: false,
      }
    case Types.GET_SERVER_DATE_SUCCEEDED:
      return {
        ...state,
        getServerDateIsLoading: false,
        getServerDateError: null,
        isServerDateSync: true,
      }
    case Types.GET_SERVER_DATE_FAILED:
      return {
        ...state,
        getServerDateIsLoading: false,
        getServerDateError: action.payload,
        isServerDateSync: false,
      }

    default:
      return state
  }
}
